/**
 *
 * Asynchronously loads the component for Reservations History Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const History = lazyLoad(
  () => import('./index'),
  module => module.HistoryPage,
);
